import { render, staticRenderFns } from "./partIntroHeader.vue?vue&type=template&id=3ff81566"
import script from "./partIntroHeader.vue?vue&type=script&lang=js"
export * from "./partIntroHeader.vue?vue&type=script&lang=js"
import style0 from "./partIntroHeader.vue?vue&type=style&index=0&id=3ff81566&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports